import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-consulta',
  templateUrl: './footer-consulta.component.html',
  styleUrls: ['./footer-consulta.component.scss']
})
export class FooterConsultaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
